import Vue from 'vue'
import '../stylesheets/tailwind'
import App from '../inserate/app.vue'

// booking.arbogast.at/programm/inserate
// getting js and compiled css

console.log('env:', process.env.NODE_ENV.trim())

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#inserate',
    render: h => h(App)
  })
  // console.log(app)
})
